import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { findAgent } from "../data/agents";

export default function AgentPlaceholderPage() {
  const { slug } = useParams();
  const agent = findAgent(slug);

  if (!agent) {
    return <Navigate to="/servizi/agenti-ai" replace />;
  }

  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to="/servizi/agenti-ai"
        data-testid="agent-back-link"
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        Torna ad Agenti AI
      </Link>

      <div
        data-testid="agent-placeholder"
        className="grid md:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] gap-10 lg:gap-14 items-start"
      >
        <div className="relative rounded-2xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_25px_80px_-20px_rgba(0,0,0,0.7)]">
          <img
            src={agent.image}
            alt={agent.name}
            data-testid="agent-image"
            className="w-full h-auto object-cover"
          />
        </div>

        <div>
          <div className="text-[11px] tracking-[0.32em] uppercase text-amber-300/80 mb-4">
            Agenti AI
          </div>
          <h1
            data-testid="agent-name"
            className="text-4xl sm:text-5xl font-extralight tracking-tight text-white leading-[1.05]"
          >
            {agent.name}
          </h1>
          <p className="mt-3 text-lg font-light text-white/60 leading-relaxed">
            {agent.role}
          </p>
          <p className="mt-6 text-white/70 font-light leading-relaxed max-w-xl">
            {agent.tagline}
          </p>

          {agent.chatUrl && (
            <a
              href={agent.chatUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                // In ambienti embedded (iframe della preview) target="_blank"
                // può essere reindirizzato nel frame corrente, causando
                // ERR_BLOCKED_BY_RESPONSE per via degli header X-Frame-Options
                // di ChatGPT. Forziamo l'apertura in una nuova scheda vera.
                e.preventDefault();
                window.open(agent.chatUrl, "_blank", "noopener,noreferrer");
              }}
              data-testid={`agent-chat-link-${agent.slug}`}
              className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-500/90 text-black text-sm tracking-wide font-medium hover:bg-emerald-400 transition"
            >
              Parla con {agent.name}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
